import {putMethod} from '~/api'

async function put(request) {
    return await putMethod('/api/invoicePaymentByKey', request)
}

export {put}
